import React from 'react';
import classNames from 'classnames/bind';
import enhance from './enhance';
import PaidPeriod from './PaidPeriod';
import styles from './Indicator.scss';


const cx = classNames.bind(styles);
type Props = {
  isPaid: boolean,
  isFree: boolean,
  arcOffset: number,
  circleLen: number,
  units: string,
  daysLeft: number,
  paymentTo: ?string,
  showCircle: boolean,
  footnotes: Object,
};

const Indicator = ({
  isPaid,
  isFree,
  arcOffset,
  circleLen,
  units,
  daysLeft,
  paymentTo,
  showCircle,
  footnotes,
}: Props) => (
  <div className={styles.root}>
    {showCircle && (daysLeft || daysLeft === 0)
      && <div className={cx({ circle: true, danger: !isPaid })}>
        <div className={styles.circleNum}>{daysLeft}</div>
        <div className={styles.circleText}>{units}</div>

        <svg viewBox="0 0 50 50" className={styles.circleBack}>
          <path
            d="M49,25c0,13.254-10.745,24-24,24 C11.746,49,1,38.254,1,25S11.746,1,25,1C38.255,1,49,11.746,49,25z"
          />
        </svg>
        <svg viewBox="0 0 50 50" className={styles.circleFront}>
          <path
            strokeDasharray={`${circleLen} ${circleLen}`}
            strokeDashoffset={circleLen}
            d="M49,25c0,13.254-10.745,24-24,24 C11.746,49,1,38.254,1,25S11.746,1,25,1C38.255,1,49,11.746,49,25z"
          >
            <animate
              attributeName="stroke-dashoffset"
              from={circleLen}
              to={arcOffset}
              dur="0.5s"
              repeatCount="0"
              fill="freeze"
            />
          </path>
        </svg>
      </div>}

    <PaidPeriod
      isPaid={isPaid}
      isFree={isFree}
      paymentTo={paymentTo}
      footnotes={footnotes}
    />
  </div>
);

export default enhance(Indicator);
